import { useEffect, useState } from 'react';
/**
 * Live IntersectionObserver hook: returns `true` while the observed element
 * intersects the viewport at >= `threshold`, updating on every cross. Unlike
 * `useBelowFoldImpression` (fire-once), this reflects the current visibility
 * state continuously. SSR-safe (returns `false` until observed).
 */
export const useIsInView = function (ref, _temp) {
  let {
    enabled = true,
    threshold = 0.1
  } = _temp === void 0 ? {} : _temp;
  const [inView, setInView] = useState(false);
  useEffect(() => {
    if (!enabled) {
      setInView(false);
      return;
    }
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      return;
    }
    const observer = new IntersectionObserver(_ref => {
      let [entry] = _ref;
      if (entry) {
        setInView(entry.intersectionRatio >= threshold);
      }
    }, {
      threshold: [0, threshold, 1]
    });
    observer.observe(el);
    return () => {
      observer.unobserve(el);
      observer.disconnect();
    };
  }, [enabled, ref, threshold]);
  return inView;
};
export const useIsBelowViewport = function (ref, _temp2) {
  let {
    enabled = true
  } = _temp2 === void 0 ? {} : _temp2;
  const [isBelow, setIsBelow] = useState(false);
  useEffect(() => {
    if (!enabled) {
      setIsBelow(false);
      return;
    }
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') {
      return;
    }
    const observer = new IntersectionObserver(_ref2 => {
      let [entry] = _ref2;
      if (entry) {
        setIsBelow(!entry.isIntersecting && entry.boundingClientRect.top > 0);
      }
    }, {
      threshold: 0
    });
    observer.observe(el);
    return () => {
      observer.unobserve(el);
      observer.disconnect();
    };
  }, [enabled, ref]);
  return isBelow;
};
//# sourceMappingURL=useIsInView.js.map